import { render } from "./RelatedPurchaseList.vue?vue&type=template&id=c78d777c&scoped=true&ts=true&lang=pug"
import script from "./RelatedPurchaseList.vue?vue&type=script&lang=ts&setup=true"
export * from "./RelatedPurchaseList.vue?vue&type=script&lang=ts&setup=true"

import "./RelatedPurchaseList.vue?vue&type=style&index=0&id=c78d777c&scoped=true&lang=less"

import exportComponent from "/Users/yangkeneng/Projects/mddh5-master/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c78d777c"]])

export default __exports__